import { render, staticRenderFns } from "./FeedbackComment.vue?vue&type=template&id=29bddc00&"
import script from "./FeedbackComment.vue?vue&type=script&lang=js&"
export * from "./FeedbackComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stevetentrop/workspace2/developer-environment/plugins/Feedback/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29bddc00')) {
      api.createRecord('29bddc00', component.options)
    } else {
      api.reload('29bddc00', component.options)
    }
    module.hot.accept("./FeedbackComment.vue?vue&type=template&id=29bddc00&", function () {
      api.rerender('29bddc00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/singleitem/FeedbackComment.vue"
export default component.exports